import * as SERVICES from '@/drc/services/drc-request-service';
import {EventSideMenu} from "@/common/configurations/event-bus.js";
import {searchFilterMixin} from "@/drc/mixins/search-filter-mixin";
import {PAGE_NAME} from "@/common/utils/constants";
import * as STATISTIC_SERVICE from "@/common/services/statistic-service";

const slideMenuMixin = {
	mixins: [searchFilterMixin],
	data() {
		return {
			currentDisplayWidth: window.innerWidth,
			tabletDisplayPx: 1280,
			slideSteps: {
				first: 1,
				second: 2,
				third: 3
			},
			slideType: {
				industry: {
					hoverType: 'industries',
					redirectUri: '/industries',
					data: []
				},
				serviceLine: {
					hoverType: 'serviceLines',
					redirectUri: '/service-lines',
					data: []

				},
				techPractice: {
					hoverType: 'techPractices',
					redirectUri: '/tech-practices',
					data: []
				}
			}
		}
	},
	computed: {
		showLanguageOptions() {
			let mode = this.$route.query.mode;
			let preview = this.$route.query.preview;

			let allowedForViewPaths = [
				`${PAGE_NAME.manage}/${PAGE_NAME.content}`,
				`${PAGE_NAME.manage}_${PAGE_NAME.content}_${PAGE_NAME.update}`
			];

			return !(allowedForViewPaths.includes(this.$route.name) || mode || preview);
		}
	},
	methods: {
		checkIsActivePage(path) {

			return path.includes('gop')
				? (this.$route.path === path ? 'active' : '')
				: (this.$route.path.includes(path) ? 'active' : '');
		},
		triggerSearchBySubFilter(subFilter, mainFilter, event) {
			this.closeAllOpenedHovers();
			if (this.$route.name === 'search') {
				this.closeSideMenu();
				this.setDefaultQueryParams();
				this.addOrRemoveSubFilter(mainFilter, subFilter, event);
				this.rerenderFilterOptions();
			} else {
				this.redirectToSearchPageBySubFilter(mainFilter.filterType, mainFilter, mainFilter.subFilterType, subFilter);
			}
		},
		triggerSearchBySlider(singleData) {
			let filter = this.getFilterType(singleData);
			this.closeAllOpenedHovers();

			if (this.$route.name === 'search') {
				this.closeSideMenu();
				this.setDefaultQueryParams();
				this.addOrRemoveFilter(filter);
				this.rerenderFilterOptions();
			} else {
				this.redirectToSearchPage(filter.filterType, filter.id);
			}
		},
		viewAll() {
			this.closeSideMenu();
			this.closeAllOpenedHovers();
			let type = this.hoveredType === undefined ? this.$store.getters.getSideMenuField('currentType') : this.hoveredType;
			if (this.$route.name !== type.hoverType) {
				let hoverType = type.hoverType === 'techPractices' ? "TECH_PRACTICES" : (type.hoverType === 'serviceLines' ? "SERVICE_LINES" : 'INDUSTRIES')
				const props = {
					action: `LEFTSIDE_MENU_${hoverType}`,
					comment: JSON.stringify({current_route: `${this.$route.path}`, type: "BUTTON_CLICK"})
				}
				STATISTIC_SERVICE.addDrcStatistic(props);
				this.$router.push(type.redirectUri);
			}
		},
		closeSideMenu() {
			if (this.$route.name !== this.isLoginPage()) {
				EventSideMenu.$emit("close-burger-logo");
				EventSideMenu.$emit("close-sidemenu");
				EventSideMenu.$emit("close-cover");
			}
		},
		isLoginPage() {
			return this.$route.name === 'login'
				|| this.$route.name === 'sign-in'
				|| this.$route.name === 'register'
				|| this.$route.name === 'forgot-password'
				|| this.$route.name === 'confirmation'
				|| this.$route.name === 'login-options'
				|| this.$route.name === 'register-success'
				|| this.$route.name === 'reset-password'
		},
		closeAllOpenedHovers() {
			Array.from(document.getElementsByClassName('slide-menu-hover-wrapper')).forEach(elem => {
				if (elem.classList.contains('active')) {
					elem.classList.remove('active');
				}
			})
			Array.from(document.getElementsByClassName('container-layer')).forEach(elem => {
				elem.classList.remove('active');
			})
		},
		customSort(data) {
			let dataArray = [...data];

			return dataArray.sort((firstField, secondField) => {
				let translationFieldOne = this.getTranslationByCurrentLanguage(firstField);
				let translationFieldTwo = this.getTranslationByCurrentLanguage(secondField);

				return (translationFieldOne.name < translationFieldTwo.name && this.isNameNotOther(translationFieldOne.name))
					? -1
					: (translationFieldOne.name > translationFieldTwo.name ? 1 : 0)
			})
		},
		isNameNotOther(name) {
			let translations = ["Other", "Andere", "Autre", "Altro", "他の"]

			return !translations.includes(name)
		},
		getTranslationByCurrentLanguage(field) {
			return field.translations.find(translation => translation.language.name === this.$i18n.locale);
		},
		fetchIndustries() {
			SERVICES.getIndustriesForSideMenu()
				.then((response) => {
					this.slideType.industry.data = response.data;
				})
				.catch((error) => {
					console.error(error);
				})
		},
		fetchServiceLines() {
			SERVICES.getServiceLinesForSideMenu()
				.then((response) => {
					this.slideType.serviceLine.data = response.data;
				})
				.catch((error) => {
					console.error(error);
				})
		},
		fetchTechPractices() {
			SERVICES.getTechPracticesForSideMenu()
				.then((response) => {
					this.slideType.techPractice.data = response.data;
				})
				.catch((error) => {
					console.error(error);
				})
		},
		rerenderFilterOptions() {
			setTimeout(() => {
				this.$store.dispatch('setSearchByFilters', {fieldName: 'showFilters', value: true});
			}, 1);
			this.$store.dispatch('setSearchByFilters', {fieldName: 'showFilters', value: false});
		},
		changeSlide(toSlide, type) {
			this.redirectToFirstSideMenuSlideIfTypeIsNull(type);

			if (window.innerWidth <= this.tabletDisplayPx) {
				this.$store.dispatch('changeSideMenuField', {fieldName: 'currentSlide', payload: toSlide})
			}
		},
		redirectToFirstSideMenuSlideIfTypeIsNull(type) {
			if (type !== null) {
				this.$store.dispatch('changeSideMenuField', {fieldName: 'currentType', payload: type});
			} else {
				this.$store.dispatch('changeSideMenuField', {fieldName: 'currentSlide', payload: 1})
			}
		}
	}
}

export default slideMenuMixin;
